/// <reference path="../appConfig/appConfig.d.ts" />
import { Injectable, Inject } from 'ng-metadata/core';
import { RestUtils } from '../infra/restUtils.service';
import {
    AuthenticationMethod, getAuthenticationMethods, getInstitutionCode, getAttributesMap, getBackendSystem,
    getSessionTimeoutParams, isEnableSingleLogout
}
    from '../appConfig/appConfigForward';
import { getVid, getChosenKeepMeSignInConf } from '../appConfig/appConfigForward';
import { JwtUtilService } from './jwtUtil.service';
import { SearchStateService } from '../search/searchState.service';
import { getUrlContext } from '../appConfig/appConfigForward';
import { isRedirectOnlyForAuthName } from '../appConfig/appConfigForward';
import { isSaml } from '../appConfig/appConfigForward';
import { UUIDGenerator } from '../nddUtils/UUIDGenerator.service';
import { STATE_NAMES } from '../primoExplore/primoExploreStates.module';
import { JournalsService } from "../journals/journals.service";
import { PersonalizationDialogService } from '../search/personalization/personalizationDialog/personalizationDialog.service';
import { SharedSessionStorage } from "../infra/sharedSessionStorage.service";
import {Cheetah} from '../search/cheetah.service';

let storageJwt = '';
const includes = require('lodash/includes');
import { PrimoResponse } from '../infra/dataStructures/PrimoResponses/doc.interfcae';
import { StorageUtil } from "../infra/storageUtil.service";
import { MappingTablesCache } from "../mappingTablesCache/mappingTablesCache.service";
import { DatabasesService } from "../journals/databases.service";
import { SilentLoginService } from "../primoExplore/silentLogin/silentLogin.service";
import { TimeoutToastService } from "./timeoutToast/timeoutToast.service";
import { ChangeLangService } from '../infra/lang/changeLang.service';
import { config } from 'module';
import { ConfigurationUtil } from '../nddUtils/configurationUtil.service';
import {AnalyticsUtils} from "../nddUtils/analyticsUtils.service";

export const UNION_CATALOG_FAVORITE_STORAGE_KEY = 'union catalog favorites from iz view';

const _get = require('lodash/get');
const Subject = require('rxjs/Subject').Subject;
let jwtPromise;

export function bootstrapJwt() {
    return jwtPromise;
}

@Injectable()
export class UserSessionManagerService {
    private areaName: string;
    public area: PrimoResponse.IDoc[] | string[];
    private inst = getInstitutionCode();
    private userInstitution = getInstitutionCode();
    private attributesMap = getAttributesMap();
    private userSettingsUrl: string;
    private authenticationMethods: AuthenticationMethod[] = getAuthenticationMethods();
    private sessionStorageKeys: string[] = ["stickyFacets", "advancedSearchMode", "allowSavingSearchHistory", "useSearchHistory", "allowSavingMyResearchAssistanceSearchHistory", "showFavoritesWarning", "resultsBulkSize", "patronsDefaultSort", "autoExtendMySession"];
    private vid: string = getVid();
    private urlContext: string = getUrlContext();
    private uuid: string;
    private prevTabDeeplink: string;
    public userDetailsDeferred: angular.IDeferred;
    public userDetailsPromise;
    public signInObservable: Subject<any>;
    private DEFAULT_USER_SEARCH_HISTORY_OFF: string = 'default_user_search_history_off';
    private AUTO_EXTEND_MY_SESSION: string = 'autoExtendMySession';
    private jwtSyncDeferredObject: angular.IDeferred<void> | null = null;
    private jwtSyncResolved = false;

    constructor(private jwtUtilService: JwtUtilService,
        private restUtils: RestUtils,
        @Inject('SessionTimeoutService') private sessionTimeoutService,
        @Inject('$http') private $http: ng.IHttpService,
        @Inject('$location') private $location,
        @Inject('$q') private $q: ng.IQService,
        @Inject('$rootScope') private $rootScope: ng.IRootScopeService,
        @Inject('$state') private $state: angular.ui.IStateService,
        @Inject('$window') private $window,
        @Inject('I18nService') private i18nService,
        @Inject('restBaseURLs') private restBaseURLs,
        @Inject('$stateParams') private $stateParams,
        @Inject('$timeout') private $timeout: ng.ITimeoutService,
        private searchStateService: SearchStateService,
        private sharedSessionStorage: SharedSessionStorage,
        private uuidGenerator: UUIDGenerator,
        private journalsService: JournalsService,
        private personalizationDialogService: PersonalizationDialogService,
        private storageUtil: StorageUtil,
        private databasesService: DatabasesService,
        private mappingTablesCache: MappingTablesCache,
        private silentLoginService: SilentLoginService,
        private changeLangService: ChangeLangService,
        private timeoutToastService: TimeoutToastService,
        private cheetahService:Cheetah,
        private configurationUtil: ConfigurationUtil,
        private analyticsUtils: AnalyticsUtils) {
        this.uuid = this.uuidGenerator.generateUUID();
        this.userSettingsUrl = restBaseURLs.userSettingsBaseURL;
        this.userDetailsDeferred = this.$q.defer();
        this.signInObservable = new Subject();
    }

    public whenJwtSyncReady(): ng.IPromise<void> {
        console.log('[whenJwtSyncReady] returning promise; resolved?', !this.jwtSyncDeferredObject);
        if (!this.jwtSyncDeferredObject) return this.$q.resolve();
        return this.jwtSyncDeferredObject.promise;
    }

    public isGuest(jwt?): boolean {
        let retVal;

        let userName = this.getUserName(jwt);
        if (userName) {
            retVal = false;
        }
        else {
            retVal = true;
        }

        return retVal;
    }

    public getUserName(jwt?) {
        let retVal;

        let obj = jwt ? this.jwtUtilService.decodeJWT(jwt) : this.jwtUtilService.getDecodedToken();
        if (obj.signedIn || obj.userGroup !== 'GUEST') {
            retVal = obj.userName;
        }
        else {
            retVal = '';
        }

        return retVal;
    }


    public getUserNameForDisplay() {
        let retVal;

        let obj = this.jwtUtilService.getDecodedToken();
        if (obj.signedIn || obj.userGroup !== 'GUEST') {
            if (obj.displayName) {
                retVal = obj.displayName;
            } else {
                retVal = obj.userName;
            }
        }
        else {
            retVal = '';
        }

        return retVal;
    }

    public getUserLanguage() {
        return this.i18nService.getLanguage();
    }


    public createOrGetUserArea(name) {
        let area;
        this.areaName = name;
        return this.storageUtil.$localForage.getItem(this.areaName).then((data) => {
            if (data) {
                area = data;
                return area;
            }
            else {
                if (this.isUnionCatalogLogin()) {
                    return this.copyFavoritesFromUnionCatalogNZView();
                }
                else {
                    this.storageUtil.$localForage.setItem(this.areaName, []);
                }
                return [];

            }
        }).then((data) => {
            if (data) {
                return data;
            }
            return [];
        });
    }

    private copyFavoritesFromUnionCatalogNZView() {
        try {
            let unionCatalogNZFavorites = this.storageUtil.sessionStorage.getItem(UNION_CATALOG_FAVORITE_STORAGE_KEY);
            if (unionCatalogNZFavorites) {
                let favorites = JSON.parse(unionCatalogNZFavorites)
                this.storageUtil.$localForage.setItem(this.areaName, favorites);
                return favorites;
            }
            else {
                this.storageUtil.$localForage.setItem(this.areaName, []);
                return [];
            }
        }
        catch (e) {
            console.log('Error while copying favorites from union catalog NZ view. Initializing empty favorites');
            console.log("Error", e.stack);
            console.log("Error", e.name);
            console.log("Error", e.message);
            this.storageUtil.$localForage.setItem(this.areaName, []);
            return [];
        }
    }

    public getGuestJwt() {
        let lang = this.$location.search()['lang'];
        let dataToBeSent = {
            targetUrl: encodeURIComponent(this.$location.absUrl()),
            viewId: this.vid,
            isGuest: this.isGuest(),
            lang: lang ? lang : this.attributesMap.interfaceLanguage
        };
        let confUrl = '/primo_library/libweb/webservices/rest/v1/guestJwt/' + this.inst;
        if (getBackendSystem() === 'suprima') {
            confUrl = '/primaws/rest/pub/institution/' + this.inst + '/guestJwt';
        }
        let conf = {
            url: confUrl,

            // This makes it so that this request doesn't send the JWT
            skipAuthorization: true,
            method: 'GET',
            params: dataToBeSent
        } as ng.IRequestConfig;
        jwtPromise = this.$http<string>(conf).then((response) => {
            return this.guestJwtResponseHandler(response);
        });
        return jwtPromise;
    }

    public guestJwtResponseHandler(response) {
        let id_token = response.data;
        if (id_token.includes('http') && this.getAuthenticationSystem() !== 'SAML' && this.getAuthenticationSystem() !== 'PDS') {
            // this means - SSO is enabled and it goes to check against the authentication server
            // Currently we disable both SAML AND PDS SSO as we do not want users to be stuck in the IDP login page
            this.$window.location.assign(id_token);
            //for typescript compiler
            return id_token;
        } else {
            let jwt = this.getJwt();
            id_token = id_token || storageJwt || jwt;
            return id_token;
        }
    }

    public getJwt() {
        return this.jwtUtilService.getJwtFromLocalStorage();
    }

    public syncJwtWithTabs(jwt) {
        this.storageUtil.localStorage.setItem('tempJWT', JSON.stringify({ jwt: jwt, uuid: this.uuid, vid: getVid() }));
    }

    public login(jwt) {
        //trigger event for other tabs
        let isGuest = this.isGuest(jwt);
        let alreadyLoggedIn = false;
        if (this.getUserName()) {
            alreadyLoggedIn = true;
        }
        if (this.$location.absUrl().includes('performLogout=true') || !isGuest) {
            this.syncJwtWithTabs(jwt);
            this.storageUtil.localStorage.removeItem('tempJWT');
        }
        if (this.isGuest() || !isGuest || !this.isJWTValidForApp(this.getJwt())) {
            this.jwtUtilService.storeJwt(jwt);
            this.analyticsUtils.storeDeviceId(jwt);
        }
        let personalSettingsPromise;
        if (this.getUserName() && this.getUserName().length > 0) { //only if logged-in
            this.getAdvancedModeFromDBandUpdateSession();
            this.removeloggedOffAfterExtendedSessionFromStorage();
        }
        let lang = this.getInterfaceLanguage(); //guest: current interface language. signed-in: user's default language
        if (alreadyLoggedIn) {
            lang = this.attributesMap.interfaceLanguage; //in case we refreshed the page while signed-in, we want to use the current interface language and not the user's default langauge
        }
        let currentInterfaceLanguage = this.attributesMap.interfaceLanguage; //updates after refresh
        let langParamInURL = this.$location.search().lang;

        let configPromise;
        this.i18nService.setLanguage(lang).then(() => {

            let institution = this.getUserInstitutionCode();

            if (this.userInstitution !== institution) {

                this.userInstitution = institution;

                let restUrl = '/primo_library/libweb/webservices/rest/v1/configuration/';
                if (getBackendSystem() === 'suprima') {
                    restUrl = '/primaws/rest/pub/configuration/vid/';
                }
                let configUrl = window.location.protocol + '//' + window.location.host + restUrl + this.vid + '?institution=' + institution;

                configPromise = this.$http.get(configUrl).then(
                    (response: { data: AppConfig }) => {
						let citations = window.appConfig.citations;
                        window.appConfig = response.data;
                        window.appConfig.vid = this.vid;
						window.appConfig.citations = citations;
                    });
            }


            if ((langParamInURL || lang != currentInterfaceLanguage)) {    //to keep the current behavior of not adding the lang parameter to the URL when we don't have it there initially 
                this.$timeout(() => {
                    this.changeLangService.addLangParamToUrl(lang);
                }, 2000)
            }


            this.updateUserDetailsInForage();
            
            if (!this.isGuest()) { //only if logged-in
                personalSettingsPromise = this.getUserSettingsFromDBandUpdateSession().then(() => {
                    this.sessionTimeoutService.startSession(this.isGuest());
                });
            } else{
                this.sessionTimeoutService.startSession(this.isGuest());
            }
        });
        return this.$q.all([personalSettingsPromise, configPromise]);
    }

    getInterfaceLanguage() {
        let lang = this.attributesMap.interfaceLanguage;
        //when guests changes the language, it doesn't reflect in his jwt
        if (this.isGuest() && this.$stateParams.lang) {
            lang = this.$stateParams.lang;
        }
        if (!this.isGuest() && this.jwtUtilService.getDecodedToken().language) {
            lang = this.jwtUtilService.getDecodedToken().language;
        }
        return lang;
    }


    getUserInstitutionCode() {
        return this.jwtUtilService.getDecodedToken().institution;
    }

    public logout(sessionTimeout: boolean) {
        this.personalizationDialogService.resetPersonalization();

        // Adds an indication before loggning-out in order to show the correct time-out toast after log-out 
        if (this.autoExtendSessionEnabledByUser()){
            this.sharedSessionStorage.setItem('loggedOffAfterExtendedSession', 'true');
        }

        //clean the desired keys from the shared session storage
        for (let key of this.sessionStorageKeys) {
            this.sharedSessionStorage.removeItem(key);
        }

        //solves infinite loop problem, because now session is started
        if (sessionTimeout) {
            this.sessionTimeoutService.startSession(true);
        }

        this.i18nService.setLanguage(this.attributesMap.interfaceLanguage).then(() => {
            let shouldRedirectToUrl = true;
            if (this.$state.current.name === 'servicesPage'
                || (getBackendSystem() === 'suprima' && this.journalsService.isJournalSearch())) {
                // We do not want to be redirected to home page
                shouldRedirectToUrl = false;
            }
            if (this.isGuest() && !this.isLoggedInIDP() || (sessionTimeout && getBackendSystem() === 'suprima' && !isEnableSingleLogout())) {
                shouldRedirectToUrl = shouldRedirectToUrl && !sessionTimeout; //if we are guest and there is a session timeout we only want to refresh the page and not redirect
                this.guestLogout(shouldRedirectToUrl);
            }
            else {
                this.userLogout(sessionTimeout, shouldRedirectToUrl);
            }
            this.sharedSessionStorage.setItem('userLogStatus', 'logout');
        });
    }

    public isLoggedInIDP() {
        if (this.sharedSessionStorage.getItem('loggedInIDP') && this.sharedSessionStorage.getItem('loggedInIDP') === 'true' &&
            this.sharedSessionStorage.getItem('authenticationProfile')) {
            return true;
        }
        return false;
    }

    public runStartupCode() {

        this.prevTabDeeplink = window.location.href;

        // initialize deferred for JWT sync
        console.log('[runStartupCode]', new Date().toISOString(), 'top?', window.top === window.self);
        this.jwtSyncDeferredObject = this.$q.defer();
        const resolveJwtSync = () => {
            if (!this.jwtSyncResolved && this.jwtSyncDeferredObject) {
                this.jwtSyncResolved = true;
                console.log('[runStartupCode] resolving jwtSyncDeferred (tab uuid =', this.uuid, ')');
                this.jwtSyncDeferredObject.resolve();
                this.jwtSyncDeferredObject = null; // one-time resolve
            }
        };

        // Ask other tabs for JWT (this is triggering the event) if we do not have it
        let jwt = this.getJwt();
        if (!jwt || this.isGuest(jwt)) {
            this.storageUtil.localStorage.setItem('getJWTFromSessionStorage', this.uuid);
        } else {
            // We already have JWT, no need to wait
            console.log('[runStartupCode] already have JWT, skip broadcast');
            resolveJwtSync();
        }

        this.$timeout(resolveJwtSync, 200, false);

        // transfers JWT from one tab to another
        let jwtTransfer = (event) => {
            if (!event) { event = window.event; } // for ie
            if (!event.newValue || event.newValue === this.uuid) { return }; // do nothing if no value to work with or we have caught our own event (stupid IE)

            if (event.key === 'getJWTFromSessionStorage' && this.getJwt()) {
                // another tab asked for the JWT -> send it
                this.storageUtil.localStorage.setItem('tempJWT', JSON.stringify({ jwt: this.getJwt(), uuid: this.uuid, vid: getVid() }));

                // the other tab should now have it, so we're done with it.
                this.storageUtil.localStorage.removeItem('tempJWT');
            }
            else if (event.key === 'tempJWT') {
                let newVal = JSON.parse(event.newValue);
                if (newVal && (newVal.uuid !== this.uuid) && (newVal.vid === getVid()) && (newVal.jwt !== storageJwt) && (newVal.jwt !== this.getJwt()) &&
                    (this.isGuest()) && (!this.isGuest(newVal.jwt))) {
                    storageJwt = newVal.jwt;
                    // another tab sent data <- get it
                    this.jwtUtilService.storeJwt(newVal.jwt);
                    this.sessionTimeoutService.startSession(false);
                    //                    this.$rootScope.$apply();
                    resolveJwtSync();  // signal sync complete
                    this.prevTabDeeplink = this.prevTabDeeplink.replace(/(loginId=.*?)(&|(\%26)|$)/i, '');

                    if (this.$state.current.name === 'login') {// we are in login state and we have deepLink saved from before the login process
                        window.location.assign(this.prevTabDeeplink);
                    }
                    else {// the login was done in another tab an we refresh the current tab to login
                        this.signInObservable.next(); //fire observable so that any observer can react to sign in due to jwt sharing between tabs
                        this.$state.reload();
                    }
                }
            }
            else if (event.key === 'logout') {
                let newVal = JSON.parse(event.newValue);
                if (newVal && (newVal.uuid !== this.uuid) && (newVal.vid === getVid())) {
                    this.jwtUtilService.removeJwt();
                    if (newVal.jwt) {
                        this.jwtUtilService.storeJwt(newVal.jwt);
                    }
                    /* In case we get the logout event in a tab that has indication in the url that the login process in primo failed,
                    we need to clean the url so we won't see the "bor-info" alert again
                    */
                    this.cleanURL();
                    this.$rootScope.$apply();
                }
            }
        };

        // listen for changes to localStorage
        if (window.addEventListener) {
            window.addEventListener("storage", jwtTransfer, false);
        } else {
            (<any>window).attachEvent("onstorage", jwtTransfer);
        }

        if (this.$location.absUrl().includes('performLogout=true')) {
            this.$location.search('performLogout', null);
            //because of a bug in PDS - '&' becomes '&amp;'
            this.$location.search('amp;performLogout', null);
        }
        if (this.$location.absUrl().includes('timeout=true')) {
            this.$location.search('timeout', null);
            //because of a bug in PDS - '&' becomes '&amp;'
            this.$location.search('amp;timeout', null);
            //in case keep me signed in is enabled, we present timeout toast from PrimoExplore.directive - we don't want to show this one as well
            if (this.isGuest() && !this.isKeepMeSignInEnabled()) {   
                this.timeoutToastService.showTimeOutToastMessage = true;
                this.timeoutToastService.showTimeoutLogoutToast();
            }
        }
    }

    public performLocalLogout(resetSearch: boolean) {
        this.local_logout().then(() => this.goToHomepage(resetSearch), () => this.goToHomepage(resetSearch));
    }

    public updateUserArea(obj) {
        if (!this.area) {
            throw 'trying to update user area without creating it';
        }
        let area = this.area as any;
        area.unshift(obj);
        // angular.merge(this.area,obj);

        return this.storageUtil.$localForage.setItem(this.areaName, this.area);
    }


    public removeRecordFromFavorites(index) {
        let area = this.area as any;
        area.splice(index, 1);
        return this.storageUtil.$localForage.setItem(this.areaName, this.area);
    }


    public extendUserArea(array) {
        let area = this.area as any;
        this.area = area.concat(array);
        return this.storageUtil.$localForage.setItem(this.areaName, this.area);

    }

    public removeArrayOfRecords(records) {
        for (let i = 0; i < this.area.length; i++) {
            let recordId = this.returnRecordId(this.area[i]);
            if (includes(records, recordId)) {
                let area = this.area as any;
                area.splice(i, 1);
                i = i - 1;
            }
        }
        return this.storageUtil.$localForage.setItem(this.areaName, this.area);
    }

    public returnRecordId(item) {
        if (this.isGuest()) {
            return item.pnx.control.recordid[0];
        }
        return item;
    }
    private getAuthenticationMethodForSSO() {
        //TBD- add the logic to decide which method to choose for SSO if there is more than one
        return this.authenticationMethods[0].profileName;
    }

    private getAuthenticationSystem() {
        return this.authenticationMethods[0].authenticationSystem;
    }

    private guestLogout(shouldRedirectToUrl: boolean) {
        return this.local_logout().then(() => {
            if (shouldRedirectToUrl) {
                this.$window.location.assign(this.getHomePage());
            } else {
                // We want to stay in the same page if redirect is not required
                this.$window.location.reload();
            }
        });
    }

    private userLogout(sessionTimeout: boolean, shouldRedirectToUrl: boolean) {
        // This is the flow:
        //	1. Get redirect URL from the server (only for external methods, will be empty for internal methods
        //	2. Logout from new UI (remove the JWT and get a guest JWT)
        //	3. Logout from the server in external methods - manipulate the redirectUrl if required
        //	4. Handle all other logic for the logout

        // We have to go get the redirectUrl from the server before we delete the JWT
        // because the REST API needs the JWT in order to work
        this.remoteLogout(sessionTimeout, shouldRedirectToUrl).then((redirectUrl) => {
            this.local_logout().then(() => {
                if (redirectUrl) {
                    // External login method, need to redirect to the IDP page
                    this.$window.location.assign(redirectUrl);
                }
                else {
                    // Internal login method
                    if (shouldRedirectToUrl) {
                        this.goToHomepage(true, sessionTimeout);
                    }
                    else {
                        this.$window.location.reload();
                    }
                }
            },
                (error) => {
                    console.log('local logout failed: ' + error);
                    this.goToHomepage(true, sessionTimeout);
                });
        },
            (error) => {
                console.log('Failed getting redirectUrl: ' + error);
                this.goToHomepage(true, sessionTimeout);
            });
    }

    private addFlagOfLogout(redirectUrl) {
        // We add "performLogout=true" so that when the UI will be reloaded, it will run the local logout (remove the JWT and go to homepage)
        //We will add this ONLY if the logout method is not SAML or if it is SAML but 'REDIRECT_ONLY' param is false

        let authenticationProfile = this.jwtUtilService.getDecodedToken().authenticationProfile;
        let redirectOnly = authenticationProfile ? isRedirectOnlyForAuthName(authenticationProfile) : 'false';
        if (authenticationProfile && !isSaml(authenticationProfile) || (isSaml(authenticationProfile) && redirectOnly === 'false')) {
            redirectUrl += '%26performLogout=true'; // The '&' should be encoded
        }
        return redirectUrl;

    }

    private goToHomepage(resetSearch: boolean, sessionTimeout) {
        if (resetSearch) {
            this.searchStateService.setSearchObject({});
            this.searchStateService.setResultObject({});
        }

        let url = this.getHomePage();
        url = sessionTimeout ? url + '&timeout=true' : url;

        if (this.$state.current.name === 'delivery' || this.$state.current.name === 'canonDelivery' || this.$state.current.name === 'cnameDelivery') {
            url = this.$window.location.pathname + this.$window.location.search;
        }
        if (this.$state.current.name === 'deposit') {
            url = '/deposit/' + this.inst;
        }
        this.$window.location.assign(url);
    }

    private getHomePage() {
        if (getBackendSystem() === 'suprima' && this.attributesMap.sessionTimeoutURL) {
            return this.attributesMap.sessionTimeoutURL;
        }
        return this.$state.href(STATE_NAMES.SEARCH, { vid: this.vid }, { inherit: false, absolute: true });
    }

    private remoteLogout(sessionTimeout: boolean, shouldRedirectToUrl: boolean) {
        this.cleanURL();
        let targetUrl;
        if (shouldRedirectToUrl) {
            targetUrl = this.getHomePage();
            if (window.appConfig['system-configuration'].temp_logout_url_double_encoding_fix) {
                targetUrl = decodeURIComponent(targetUrl);
            }
        } else {
            targetUrl = this.$location.absUrl();
        }
        targetUrl = encodeURIComponent(targetUrl);
        targetUrl += sessionTimeout ? '%26timeout=true' : '';
        targetUrl = this.addFlagOfLogout(targetUrl);
        let inputData = {
            sessionTimeout: 'false',
            targetURL: targetUrl,
        };
        if (sessionTimeout) {
            inputData.sessionTimeout = 'true';
        }
        if (this.isLoggedInIDP()) {
            inputData.authenticationProfile = this.sharedSessionStorage.getItem('authenticationProfile');
            this.sharedSessionStorage.removeItem('loggedInIDP');
            this.sharedSessionStorage.removeItem('authenticationProfile');

        }
        let logOutUrl = '/primo_library/libweb/primoExploreLogout';
        if (getBackendSystem() === 'suprima') {
            logOutUrl = '/primaws/suprimaLogout';
        }
        return this.restUtils.postToServlet(logOutUrl, inputData)
            .then((response: { data: { redirect } }) => {
                let redirect_url = response.data.redirect;
                return redirect_url;
            });
    }

    //In case there is a guest that logged in the IDP but not in primo, we want to clean the url before calculating target URL
    private cleanURL() {
        if (this.$location.search()['authenticationError']) {
            this.$location.search('authenticationError', null);
        }
        if (this.$location.search()['authenticationProfile']) {
            this.$location.search('authenticationProfile', null);
        }
        if (this.$location.search()['from-new-ui']) {
            this.$location.search('from-new-ui', null);
        }
    }

    private getGuestJwtWithTimeout(timeout: number) {
        return this.$q((resolve, reject) => {
            setTimeout(() => { reject(); }, timeout)
            this.getGuestJwt().then((guestJwt) => {
                resolve(guestJwt);
            });
        });
    }

    private async local_logout() {
        let guestJwt;
        try {
            guestJwt = await this.getGuestJwtWithTimeout(4000);
        }
        catch (err) {
            console.error('get guest jwt failed or timed out');
        }
        this.storageUtil.localStorage.setItem('logout', JSON.stringify({ uuid: this.uuid, vid: getVid(), jwt: guestJwt }));
        this.storageUtil.localStorage.removeItem('logout');
        this.jwtUtilService.removeJwt();
        if (guestJwt) {
            this.jwtUtilService.storeJwt(guestJwt);
        }
        return this.storageUtil.$localForage.clear();
    }



    private updateUserDetailsInForage() {
        let userDetailsUrl = this.userSettingsUrl + '?vid=' + this.vid;
        let userDetailsPromise = this.$http({
            method: 'GET',
            url: userDetailsUrl,
        });
        userDetailsPromise.then((response) => {
            this.userDetailsDeferred.resolve(response);
            this.storageUtil.$localForage.setItem('userDetails', response.data);

        },
            (error) => {
                console.error(error);
            });
    }

    private getUserSettingsFromDBandUpdateSession() {
        let userDetailsUrl = this.userSettingsUrl + '?vid=' + this.vid;
        this.userDetailsPromise = this.$http({
            method: 'GET',
            url: userDetailsUrl,
        });
        let defaultValueForToggles = this.getDefaultValueForToggles();
        return this.userDetailsPromise.then(
            (response) => {
                if (_get(response, 'data.autoExtendMySession')) {
                    this.sharedSessionStorage.setItem('autoExtendMySession', response.data.autoExtendMySession);
                }

                if (_get(response, 'data.saveSearchHistory')) {
                    this.storageUtil.sessionStorage.setItem('allowSavingSearchHistory', response.data.saveSearchHistory);
                }
                else {
                    this.storageUtil.sessionStorage.setItem('allowSavingSearchHistory', defaultValueForToggles);
                }
                if (_get(response, 'data.useSearchHistory')) {
                    this.storageUtil.sessionStorage.setItem('useSearchHistory', response.data.useSearchHistory);
                }
                else {
                    this.storageUtil.sessionStorage.setItem('useSearchHistory', defaultValueForToggles);
                }
                if (_get(response, 'data.allowSavingMyResearchAssistanceSearchHistory')) {
                    this.storageUtil.sessionStorage.setItem('allowSavingMyResearchAssistanceSearchHistory', _get(response, 'data.allowSavingMyResearchAssistanceSearchHistory'));
                }
                if (_get(response, 'data.resultsBulkSize')) {
                    this.sharedSessionStorage.setItem('resultsBulkSize', response.data.resultsBulkSize);
                }
                if (this.cheetahService.isPatronsDefaultSortEnabled()) {
                    this.storageUtil.sessionStorage.setItem('patronsDefaultSort', response.data.patronsDefaultSort);
                }
            },
            (error) => {
                this.storageUtil.sessionStorage.setItem('allowSavingSearchHistory', 'true');
                this.storageUtil.sessionStorage.setItem('useSearchHistory', 'true');
                this.storageUtil.sessionStorage.setItem('allowSavingMyResearchAssistanceSearchHistory', 'true');
                console.error(error);
            }
        );
    }

    private getDefaultValueForToggles() {
        let defaultValueForTogglesBoolean = !(this.mappingTablesCache.findByProperties(this.mappingTablesCache.tables.INSTITUTION_PROPERTIES, { target: 'true', source1: this.DEFAULT_USER_SEARCH_HISTORY_OFF }).length > 0);
        let defaultValueForTogglesStr = defaultValueForTogglesBoolean.toString();
        // if this parameter not exists in the MT (OTB) then the default should be 'true' (enabled toggles)
        return defaultValueForTogglesStr || 'true';

    }

    private removeloggedOffAfterExtendedSessionFromStorage(){
        this.sharedSessionStorage.removeItem('loggedOffAfterExtendedSession');
    }

    private getAdvancedModeFromDBandUpdateSession() {
        let userDetailsUrl = this.userSettingsUrl + '?vid=' + this.vid;
        let userDetailsPromise = this.$http({
            method: 'GET',
            url: userDetailsUrl,
        });
        userDetailsPromise.then(
            (response) => {
                if (_get(response, 'data.advanced_mode')) {
                    this.sharedSessionStorage.setItem('advancedSearchMode', response.data.advanced_mode);
                }
                else {
                    this.sharedSessionStorage.removeItem('advancedSearchMode');
                }
            },
            (error) => {
                console.error(error);
            }
        );
    }

    public isJWTValidForApp(jwt) {
        if (!jwt) {
            console.log('no jwt so invalid');
            return false
        }
        let decodedJWT = this.jwtUtilService.decodeJWT(jwt);
        let jwtVid = decodedJWT.viewId;
        let appVid = getVid();
        let viewInstitutionCode = getInstitutionCode();
        let jwtViewInstitutionCode = decodedJWT.institution;
        if ((jwtVid === appVid) || (!this.isGuest() && (this.isViewCentral(appVid) || jwtViewInstitutionCode === viewInstitutionCode))) {
            return true;
        }
        return false;
    }

    private isViewCentral(vid: string): boolean {
        let mtLine = this.mappingTablesCache.findByProperties('Central View Configuration', { source1: 'Keep users signed-in when switching to or from view', source2: 'true', target: vid });
        return mtLine && mtLine.length > 0;
    }

    public isUnionCatalogLogin() {
        return this.$stateParams.unionCatalogNZVid != undefined;
    }

    private autoExtendSessionEnabledByUser(): boolean{
        return this.sharedSessionStorage.getItem(this.AUTO_EXTEND_MY_SESSION) === 'true';
    }

    private isKeepMeSignInEnabled() {
        let chosenConf = getChosenKeepMeSignInConf();

        if(this.configurationUtil.getBackendSystem() === 'suprima'){
            let keepMeSignInFeatureFlag = this.configurationUtil.getFeatureFlag('enable_patrons_to_check_keep_me_signed_in');
            return chosenConf != null && keepMeSignInFeatureFlag;
        }

        return chosenConf != null;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/security/userSessionManager.service.ts